import { CART_SYNC_PRICES } from '../../../shared/constants/api';
import * as api from '../../../shared/services/apiClient';
import { CartView } from '../types/cartTypes';

export async function applyDiscount(cartId: string): Promise<{ cart: CartView; priceChanges?: unknown[] }> {
  const response = await api.post(CART_SYNC_PRICES, { cartId });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(errorData.error ?? 'Failed to sync cart prices');
  }
  return response.json();
}
